// import logo from './logo.svg';
import "./App.css";
import BookingSearchBar from "./BookingSearchBar.jsx";
import ListingDetail from "./ListingDetail.jsx";
// import ListingDetailDemo from "./ListingDetailDemo.jsx";
import SwiperGallery from "./SwiperGallery.jsx";
import PhpListingsWithFilters from "./PhpListingsWithFilters.jsx";

function App() {
  const isProd = process.env.NODE_ENV === "production";
  const handleSearch = ({ checkIn, checkOut, guests }) => {
    console.log("React search:", checkIn, checkOut, guests);

    // המתנה עד שהפונקציה הגלובלית זמינה
    const interval = setInterval(() => {
      if (window.searchListings) {
        clearInterval(interval);
        window.searchListings(checkIn, checkOut, guests);
      }
    }, 100);
  };

  return (
    <>
      <BookingSearchBar onSearch={handleSearch} />
      {/* <PhpListingsWithFilters /> */}
      {!isProd && (
        <>
          <SwiperGallery />
          <ListingDetail />
        </>
      )}
    </>
  );
}

export default App;
